import { FormCentralizer } from '@/components';
import { useMessage } from '@/providers';
import type { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router';
import { useCreateUser } from '../../hooks';
import { UserForm } from './UserForm';

export const CreateUserPage: FC = () => {
  const navigate = useNavigate();
  const { openMessage } = useMessage();
  const { t } = useTranslation();
  const { mutateAsync: createUser } = useCreateUser();

  return (
    <FormCentralizer>
      <UserForm
        onSubmit={async (values) => {
          try {
            const res = await createUser(values);

            await Promise.all([
              openMessage(
                'success',
                t(
                  'message-created-user-and-sent-password-initialization-email',
                ),
              ),
              (async () => {
                navigate(`/tenant-manager/users/${res.id}`, { replace: true });
              })(),
            ]);
          } catch {
            await openMessage('error', t('message-save-failed'));
          }
        }}
      />
    </FormCentralizer>
  );
};
